//
//
//
//
//
//
//
//
//

export default {
  name: 'OpInput',
  props: {
    inputValue: {
      // 文本形式显示的内容
      type: String,
      default: ''
    },
    isReadonly: {
      // 是否只读（文本形式显示）
      type: Boolean,
      default: false
    }
  }
};